import { render, staticRenderFns } from "./TechnicalManagementTabs.vue?vue&type=template&id=7955cb65&"
import script from "./TechnicalManagementTabs.vue?vue&type=script&lang=js&"
export * from "./TechnicalManagementTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports